import React from "react";
import { GiftIcon } from "lucide-react";
import { BonusCarousel } from "./BonusCarousel";
export function Bonos() {
  return <section className="w-full bg-beige px-5 py-10" data-id="element-21" data-mp="2hdctlohki8u1">
      <div className="mx-auto max-w-md" data-id="element-22" data-mp="2leewcfap130r">
        <div className="rounded-2xl border border-gold/40 bg-cream p-5 text-center" data-id="element-23" data-mp="2lddbjj3vl25u">
          <GiftIcon className="mx-auto h-8 w-8 text-gold" aria-hidden="true" data-id="element-24" data-mp="2q5wxp4gmp5m9" />
          <h2 className="mt-2 font-serif text-2xl font-bold text-deep-green" data-id="element-25" data-mp="2v36nwmbudlb5">
            ¡Espera! Sabemos que tramitar la ciudadanía no es tan sencillo.
          </h2>
          <p className="mt-2 text-sm text-ink/75" data-id="element-26" data-mp="351m9yaw0i4ds">
            Por eso te damos también estas herramientas:
          </p>
          <span className="mt-3 inline-block rounded-full bg-gold px-3 py-1 text-xs font-bold text-cream" data-id="element-27" data-mp="392g1de8ny1bf">
            🎁 GRATIS por hoy
          </span>
        </div>

        <BonusCarousel data-id="element-28" data-mp="1ep6nla933tnd" />
      </div>
    </section>;
}